export default {
    showing: "Mostrando {0}-{1} de {2}",
    items_per_page: "Elementos por pagina:",
    go_to: "Ir a:",
};
